/**
 * Dynamic placeholders per email type for the admin "Insert dynamic value" dropdown.
 * Each type lists only the placeholders used when sending that email.
 * labelKey: message key for localized label (see locale jsonMessages).
 */
export const EMAIL_PLACEHOLDERS_BY_TYPE = {
  welcomeEmail: [
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'verificationURL', labelKey: 'emailPlaceholderVerificationLink' },
  ],
  confirmEmail: [
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'verificationURL', labelKey: 'emailPlaceholderVerificationLink' },
  ],
  bookingRequest: [
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'threadId', labelKey: 'emailPlaceholderThreadId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'actionURL', labelKey: 'emailPlaceholderAcceptDeclineUrl' },
    { key: 'basePrice', labelKey: 'basePrice' },
    { key: 'subtotal', labelKey: 'subTotalLabel' },
    { key: 'currency', labelKey: 'emailPlaceholderCurrency' },
  ],
  bookingRequestGuest: [
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  bookingConfirmedToHost: [
    { key: 'reservationId', labelKey: 'emailPlaceholderReservationId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
    { key: 'itineraryURL', labelKey: 'emailPlaceholderViewItineraryUrl' },
    { key: 'allowedCheckInTime', labelKey: 'emailPlaceholderAllowedCheckInTime' },
    { key: 'allowedCheckOutTime', labelKey: 'emailPlaceholderAllowedCheckOutTime' }
  ],
  bookingConfirmedToGuest: [
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'threadId', labelKey: 'emailPlaceholderThreadId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
    { key: 'contactURL', labelKey: 'emailPlaceholderContactHostUrl' },
  ],
  bookingDeclinedToGuest: [
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
  ],
  bookingExpiredGuest: [
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
  ],
  bookingExpiredHost: [
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  cancelledByHost: [
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'refundToGuest', labelKey: 'emailPlaceholderRefundToGuestAmount' },
    { key: 'currency', labelKey: 'emailPlaceholderCurrency' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'country', labelKey: 'emailPlaceholderCountry' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
  ],
  cancelledByGuest: [
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'payoutToHost', labelKey: 'emailPlaceholderPayoutToHostAmount' },
    { key: 'currency', labelKey: 'emailPlaceholderCurrency' }
  ],
  completedGuest: [
    { key: 'reservationId', labelKey: 'emailPlaceholderReservationId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'hostProfilePic', labelKey: 'emailPlaceholderHostProfilePic' },
    { key: 'messageURL', labelKey: 'emailPlaceholderWriteReviewUrl' },
    { key: 'imageURL', labelKey: 'emailPlaceholderHostAvatarUrl' },
  ],
  completedHost: [
    { key: 'reservationId', labelKey: 'emailPlaceholderReservationId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'messageURL', labelKey: 'emailPlaceholderWriteReviewUrl' },
  ],
  forgotPasswordLink: [
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'verificationURL', labelKey: 'emailPlaceholderResetPasswordLink' },
  ],
  message: [
    { key: 'receiverName', labelKey: 'emailPlaceholderReceiverName' },
    { key: 'senderName', labelKey: 'emailPlaceholderSenderName' },
    { key: 'message', labelKey: 'emailPlaceholderMessage' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  inquiry: [
    { key: 'receiverName', labelKey: 'emailPlaceholderReceiverName' },
    { key: 'type', labelKey: 'emailPlaceholderUserTypeHostGuest' },
    { key: 'senderName', labelKey: 'emailPlaceholderSenderName' },
    { key: 'message', labelKey: 'emailPlaceholderMessage' },
    { key: 'threadId', labelKey: 'emailPlaceholderThreadId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'checkIn', labelKey: 'emailPlaceholderCheckInDate' },
    { key: 'checkOut', labelKey: 'emailPlaceholderCheckOutDate' },
    { key: 'personCapacity', labelKey: 'emailPlaceholderPersonCapacity' },
    { key: 'messageURL', labelKey: 'emailPlaceholderMessageThreadUrl' },
  ],
  documentVerification: [
    { key: 'verificationStatus', labelKey: 'emailPlaceholderVerificationStatus' },
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'verificationURL', labelKey: 'emailPlaceholderVerificationProfileUrl' },
  ],
  contact: [
    { key: 'ContactMessage', labelKey: 'emailPlaceholderContactMessage' },
    { key: 'email', labelKey: 'emailPlaceholderEmail' },
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'phoneNumber', labelKey: 'emailPlaceholderPhoneNumber' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  reportUser: [
    { key: 'userName', labelKey: 'emailPlaceholderReportedUserName' },
    { key: 'reporterName', labelKey: 'emailPlaceholderReporterName' },
    { key: 'reportType', labelKey: 'emailPlaceholderReportType' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  bookingPreApproval: [
    { key: 'guestName', labelKey: 'emailPlaceholderGuestName' },
    { key: 'hostName', labelKey: 'emailPlaceholderHostName' },
    { key: 'threadId', labelKey: 'emailPlaceholderThreadId' },
    { key: 'listTitle', labelKey: 'emailPlaceholderListingTitle' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'contactURL', labelKey: 'emailPlaceholderBookNowMessageUrl' },
  ],
  banStatusServiceStatusBanned: [
    { key: 'userName', labelKey: 'emailPlaceholderUserName' },
    { key: 'adminMail', labelKey: 'emailPlaceholderAdminSupportEmail' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  banStatusServiceStatusUnBanned: [
    { key: 'userName', labelKey: 'emailPlaceholderUserName' },
    { key: 'adminMail', labelKey: 'emailPlaceholderAdminSupportEmail' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  contactSupport: [
    { key: 'ContactMessage', labelKey: 'emailPlaceholderContactMessage' },
    { key: 'email', labelKey: 'emailPlaceholderEmail' },
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'confirmationCode', labelKey: 'emailPlaceholderConfirmationCode' },
    { key: 'userType', labelKey: 'emailPlaceholderUserType' },
    { key: 'listId', labelKey: 'emailPlaceholderListingId' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  userFeedback: [
    { key: 'message', labelKey: 'emailPlaceholderMessage' },
    { key: 'name', labelKey: 'emailPlaceholderName' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'type', labelKey: 'emailTemplateTableType' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
  ],
  servicePlanExpired: [
    { key: 'userName', labelKey: 'emailPlaceholderUserName' },
    { key: 'planName', labelKey: 'emailPlaceholderPlanName' },
    { key: 'expiredDate', labelKey: 'emailPlaceholderExpiredDate' },
    { key: 'logo', labelKey: 'emailPlaceholderLogoUrl' },
    { key: 'siteName', labelKey: 'emailPlaceholderSiteName' },
    { key: 'planURL', labelKey: 'emailPlaceholderExplorePlansUrl' },
  ],
};
